import axios from "axios";

const prodApi = {
  login: "https://www.data.6334group.com/login",
  inquiry: "https://www.data.6334group.com/inquiries",
  bookings: "https://www.data.6334group.com/bookings",
};

const devApi = {
  inquiry: "http://localhost:6334/inquiries",
  bookings: "http://localhost:6334/bookings",
};

const api = axios.create({
  baseURL: "http://localhost:6334Group",
});

const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["authorization"] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common["authorization"];
  }
};

export { prodApi, devApi, setAuthToken };
